import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { MailService } from 'src/app/_services/dispo/mail.service';
import { DispatchStop } from './dispatch-planner.component';

export interface DispatchEmailDialogData {
  stops: DispatchStop[];
  distanceText?: string;
  durationText?: string;
}

interface EmailRecipient {
  stop: DispatchStop;
  email: string;
  selected: boolean;
}

@Component({
  selector: 'app-dispatch-planner-email-dialog',
  templateUrl: './dispatch-planner-email-dialog.component.html',
  styleUrls: ['./dispatch-planner-email-dialog.component.css']
})
export class DispatchPlannerEmailDialogComponent implements OnInit {
  form: FormGroup;
  recipients: EmailRecipient[] = [];
  sending = false;

  constructor(
    private fb: FormBuilder,
    private mailService: MailService,
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<DispatchPlannerEmailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DispatchEmailDialogData
  ) {}

  ngOnInit(): void {
    this.recipients = (this.data.stops || [])
      .filter(s => !!s.email?.trim())
      .map(stop => ({
        stop,
        email: stop.email!.trim(),
        selected: true
      }));

    const stopLines = (this.data.stops || [])
      .map(s => `${s.orderIndex}. ${s.customerName || s.kaufvertragsnummer || s.address} – ${s.address}`)
      .join('\n');

    const tourLine =
      this.data.distanceText || this.data.durationText
        ? `\n\nGeplante Tour: ${this.data.distanceText || ''} ${this.data.durationText || ''}`.trim()
        : '';

    this.form = this.fb.group({
      title: [`Tourinformation / Termin`, Validators.required],
      text: [
        `Guten Tag,\n\nhier Ihre geplante Tour:\n\n${stopLines}${tourLine}\n\nMit freundlichen Grüßen\nIhr MH3 Team`,
        Validators.required
      ]
    });
  }

  get selectedRecipients(): EmailRecipient[] {
    return this.recipients.filter(r => r.selected);
  }

  get canSend(): boolean {
    return !!this.selectedRecipients.length && this.form.valid && !this.sending;
  }

  toggleAll(checked: boolean): void {
    this.recipients.forEach(r => (r.selected = checked));
  }

  send(): void {
    if (!this.canSend) {
      return;
    }

    const recipients = this.selectedRecipients.map(r => r.email).join(', ');
    const bodyHtml = this.form.value.text.replace(/\n/g, '<br>');

    this.sending = true;
    this.mailService.store({
      title: this.form.value.title,
      text: bodyHtml,
      recipients,
      documents: JSON.stringify([])
    }).subscribe({
      next: () => {
        this.toastr.success(`E-Mail an ${this.selectedRecipients.length} Empfänger versendet.`);
        this.dialogRef.close(true);
      },
      error: err => {
        this.sending = false;
        const msg = err?.error?.message || 'E-Mail konnte nicht versendet werden.';
        this.toastr.error(msg, 'Fehler');
      }
    });
  }

  close(): void {
    this.dialogRef.close(false);
  }
}
